import img_checked from '@/assets/img/img_checked.png';
import img_uncheck from '@/assets/img/img_uncheck_v2.png';
import img_disable from '@/assets/img/img_checked_disable.png'
const CheckBox = ({
  children,
  className,
  style,
  server_list,
  value,
  onClick,
  imgDisabled
}) => {
  
  return (
    <span onClick={onClick} className={`${className} cursor-pointer`} style={style}>
      <img
        className={`w-16px mr-12px`}
        src={server_list?.includes(value) ? img_checked : (imgDisabled == 'disabled' ? img_disable :  img_uncheck)}
      />
      {children}
    </span>
  );
};

export default CheckBox;
